// [COLETA-ARQUIVOS] modal do no "Coletar arquivos"
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  root: { display: "flex", flexWrap: "wrap" },
  campo: { marginBottom: 14 },
  dica: { fontSize: 12, color: "#555", marginBottom: 14, lineHeight: "18px" },
}));

const PADRAO = {
  message: "Envie as fotos ou PDFs do pedido médico. Quando terminar, digite PRONTO.",
  variable: "pedido",
  keyword: "PRONTO",
  ack: "Recebido ✅ ({n}). Pode enviar mais ou digitar {palavra} para finalizar.",
  reminder: "",
  limit: "",
  compress: true,
};

const limparVariavel = (v) => String(v || "").replace(/[^a-zA-Z0-9_]/g, "");

const FlowBuilderAddCollectFilesModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [form, setForm] = useState(PADRAO);

  useEffect(() => {
    if (open === "edit") {
      const d = (data && data.data) || {};
      setForm({
        message: d.message || "",
        variable: d.variable || "arquivos",
        keyword: d.keyword || "PRONTO",
        ack: d.ack || "",
        reminder: d.reminder || "",
        limit: d.limit ? String(d.limit) : "",
        compress: d.compress !== false,
      });
      setActiveModal(true);
    } else if (open === "create") {
      setForm(PADRAO);
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  const set = (campo) => (e) => {
    const valor = e && e.target ? (e.target.type === "checkbox" ? e.target.checked : e.target.value) : e;
    setForm((f) => ({ ...f, [campo]: campo === "variable" ? limparVariavel(valor) : valor }));
  };

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    const limite = parseInt(form.limit, 10);
    const dados = {
      message: (form.message || "").trim(),
      variable: limparVariavel(form.variable) || "arquivos",
      keyword: (form.keyword || "").trim() || "PRONTO",
      ack: (form.ack || "").trim(),
      reminder: (form.reminder || "").trim(),
      limit: limite > 0 ? limite : 0,
      compress: !!form.compress,
    };
    if (open === "edit") {
      onUpdate({ ...data, data: { ...(data && data.data), ...dados } });
    } else if (open === "create") {
      onSave(dados);
    }
    handleClose();
  };

  const v = limparVariavel(form.variable) || "arquivos";

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
        <DialogTitle>{open === "create" ? "Adicionar coleta de arquivos" : "Editar coleta de arquivos"}</DialogTitle>
        <DialogContent dividers>
          <Typography className={classes.dica}>
            O cliente envia fotos ou PDFs (quantos quiser) e digita a palavra de término. O MFlux junta
            tudo em um arquivo ZIP e segue para o próximo nó. Áudios e vídeos são ignorados.
          </Typography>
          <TextField
            className={classes.campo}
            label="Mensagem de pedido"
            variant="outlined"
            multiline
            rows={3}
            fullWidth
            value={form.message}
            onChange={set("message")}
          />
          <TextField
            className={classes.campo}
            label="Nome da variável"
            variant="outlined"
            fullWidth
            value={form.variable}
            onChange={set("variable")}
            helperText="Só letras, números e _"
          />
          <TextField
            className={classes.campo}
            label="Palavra de término"
            variant="outlined"
            fullWidth
            value={form.keyword}
            onChange={set("keyword")}
            helperText="Não diferencia maiúsculas, acentos nem pontuação (pronto, Pronto!, PRONTO)"
          />
          <TextField
            className={classes.campo}
            label="Confirmação a cada envio (opcional)"
            variant="outlined"
            fullWidth
            value={form.ack}
            onChange={set("ack")}
            helperText="Enviada uma vez por rajada de arquivos. {n} = quantidade recebida, {palavra} = palavra de término"
          />
          <TextField
            className={classes.campo}
            label="Lembrete quando o cliente manda texto (opcional)"
            variant="outlined"
            fullWidth
            value={form.reminder}
            onChange={set("reminder")}
            helperText="Vazio = 'Envie as fotos ou PDFs e, quando terminar, digite PRONTO.'"
          />
          <TextField
            className={classes.campo}
            label="Limite de arquivos (opcional)"
            variant="outlined"
            type="number"
            fullWidth
            value={form.limit}
            onChange={set("limit")}
            helperText="Vazio ou 0 = sem limite"
          />
          <FormControlLabel
            control={<Checkbox checked={!!form.compress} onChange={set("compress")} color="primary" />}
            label="Reduzir as fotos (até 1600px, JPEG) para o ZIP ficar menor"
          />
          <Typography className={classes.dica} style={{ marginTop: 10 }}>
            Variáveis para os próximos nós (ex.: corpo do HTTP Request):
            <br />
            <b>{"${" + v + "_base64}"}</b> ZIP em base64 · <b>{"${" + v + "_qtd}"}</b> quantidade ·{" "}
            <b>{"${" + v + "_nome}"}</b> nome do arquivo · <b>{"${" + v + "_mime}"}</b> application/zip
            <br />
            Se o cliente não enviar nada, <b>{"${" + v + "_qtd}"}</b> fica 0 (use uma Condição para tratar).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            {i18n.t("contactModal.buttons.cancel")}
          </Button>
          <Button color="primary" variant="contained" onClick={handleSave}>
            {open === "create" ? "Adicionar" : "Editar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddCollectFilesModal;
